module.exports = __webpack_public_path__ + "static/media/TryToImpeachThis.27e0f31a.gif";